import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import omit from 'omit';
import DropdownLayout, { DIVIDER_OPTION_VALUE } from '../DropdownLayout/DropdownLayout';
import Highlighter from '../Highlighter/Highlighter';
import { chainEventHandlers } from '../utils/ChainEventHandlers';
import styles from './InputWithOptions.st.css';
import { placements } from '../Popover/constants';
import uniqueId from 'lodash/uniqueId';
import Popover from '../Popover';
export var DEFAULT_VALUE_PARSER = function DEFAULT_VALUE_PARSER(option) {
  return option.value;
};
var DEFAULT_POPOVER_PROPS = {
  appendTo: 'parent',
  flip: false,
  fixed: true,
  placement: 'bottom'
};

var InputWithOptions = /*#__PURE__*/function (_Component) {
  _inherits(InputWithOptions, _Component);

  var _super = _createSuper(InputWithOptions);

  _createClass(InputWithOptions, [{
    key: "inputClasses",
    // Abstraction
    value: function inputClasses() {}
  }, {
    key: "dropdownClasses",
    value: function dropdownClasses() {}
  }, {
    key: "dropdownAdditionalProps",
    value: function dropdownAdditionalProps() {}
  }, {
    key: "inputAdditionalProps",
    value: function inputAdditionalProps() {}
    /**
     * An array of key codes that act as manual submit. Will be used within
     * onKeyDown(event).
     *
     * @returns {KeyboardEvent.key[]}
     */

  }, {
    key: "getManualSubmitKeys",
    value: function getManualSubmitKeys() {
      return ['Enter', 'Tab'];
    }
  }]);

  function InputWithOptions(props) {
    var _this;

    _classCallCheck(this, InputWithOptions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onClickOutside", function () {
      // Hide the popover
      _this.hideOptions(); // Trigger the ClickOutside callback


      if (_this.props.onClickOutside) {
        _this.props.onClickOutside();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isDropdownLayoutVisible", function () {
      return _this.state.showOptions && (_this.props.showOptionsIfEmptyInput || _this.state.inputValue.length > 0);
    });

    _this.state = {
      inputValue: props.value || '',
      showOptions: false,
      lastOptionsShow: 0,
      isEditing: false
    };
    _this.uniqueId = uniqueId('InputWithOptions');
    _this._onSelect = _this._onSelect.bind(_assertThisInitialized(_this));
    _this._onFocus = _this._onFocus.bind(_assertThisInitialized(_this));
    _this._onBlur = _this._onBlur.bind(_assertThisInitialized(_this));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_this));
    _this._onKeyDown = _this._onKeyDown.bind(_assertThisInitialized(_this));
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.blur = _this.blur.bind(_assertThisInitialized(_this));
    _this.select = _this.select.bind(_assertThisInitialized(_this));
    _this.hideOptions = _this.hideOptions.bind(_assertThisInitialized(_this));
    _this.showOptions = _this.showOptions.bind(_assertThisInitialized(_this));
    _this._onManuallyInput = _this._onManuallyInput.bind(_assertThisInitialized(_this));
    _this._renderDropdownLayout = _this._renderDropdownLayout.bind(_assertThisInitialized(_this));
    _this._onInputClicked = _this._onInputClicked.bind(_assertThisInitialized(_this));
    _this.closeOnSelect = _this.closeOnSelect.bind(_assertThisInitialized(_this));
    _this.onCompositionChange = _this.onCompositionChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputWithOptions, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.props.showOptionsIfEmptyInput && (!prevProps.value && this.props.value || !prevState.inputValue && this.state.inputValue)) {
        this.showOptions();
      } // Clear value in controlled mode


      if (prevProps.value !== this.props.value && this.props.value === '') {
        this.setState({
          inputValue: ''
        });
      }
    }
  }, {
    key: "onCompositionChange",
    value: function onCompositionChange(isComposing) {
      this.setState({
        isComposing: isComposing
      });
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this2 = this;

      var inputAdditionalProps = this.inputAdditionalProps();
      var inputProps = Object.assign(omit(Object.keys(DropdownLayout.propTypes).concat(['onChange', 'dataHook']), this.props), inputAdditionalProps);
      var inputElement = inputProps.inputElement;
      return /*#__PURE__*/React.cloneElement(inputElement, _objectSpread(_objectSpread({
        menuArrow: true,
        ref: function ref(input) {
          return _this2.input = input;
        }
      }, inputProps), {}, {
        onKeyDown: chainEventHandlers(inputAdditionalProps && inputAdditionalProps.onKeyDown),
        onChange: this._onChange,
        onInputClicked: this._onInputClicked,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onCompositionChange: this.onCompositionChange,
        width: inputElement.props.width,
        textOverflow: this.props.textOverflow || inputElement.props.textOverflow,
        tabIndex: this.props["native"] ? -1 : 0
      }));
    }
  }, {
    key: "_processOptions",
    value: function _processOptions(options) {
      var _this3 = this;

      return !this.props.highlight ? options : options.map(function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          value: option.value === DIVIDER_OPTION_VALUE ? option.value : /*#__PURE__*/React.createElement(Highlighter, {
            match: _this3.state.inputValue,
            dataHook: "highlighter-".concat(option.id)
          }, option.value)
        });
      });
    }
  }, {
    key: "_renderDropdownLayout",
    value: function _renderDropdownLayout() {
      var _this4 = this;

      var inputOnlyProps = omit(['tabIndex'], Input.propTypes);
      var dropdownProps = Object.assign(omit(Object.keys(inputOnlyProps).concat(['dataHook']), this.props), this.dropdownAdditionalProps());
      var customStyle = {
        marginLeft: this.props.dropdownOffsetLeft
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(this.uniqueId, " ").concat(this.dropdownClasses()),
        style: customStyle,
        "data-hook": "dropdown-layout-wrapper"
      }, /*#__PURE__*/React.createElement(DropdownLayout, _extends({
        ref: function ref(dropdownLayout) {
          return _this4.dropdownLayout = dropdownLayout;
        }
      }, dropdownProps, {
        dataHook: "inputwithoptions-dropdownlayout",
        options: this._processOptions(dropdownProps.options),
        visible: true,
        onClose: this.hideOptions,
        onSelect: this._onSelect,
        isComposing: this.state.isComposing,
        inContainer: true,
        tabIndex: -1
      })));
    }
  }, {
    key: "_renderNativeSelect",
    value: function _renderNativeSelect() {
      var _this5 = this;

      var _this$props = this.props,
          options = _this$props.options,
          onSelect = _this$props.onSelect;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.nativeSelectWrapper
      }, this.renderInput(), /*#__PURE__*/React.createElement("select", {
        "data-hook": "native-select",
        className: styles.nativeSelect,
        onChange: function onChange(event) {
          _this5._onChange(event); // In this case we don't use DropdownLayout so we need to invoke `onSelect` manually


          onSelect(options[event.target.selectedIndex]);
        }
      }, options.map(function (option, index) {
        return /*#__PURE__*/React.createElement("option", {
          "data-hook": "native-option-".concat(option.id),
          "data-index": index,
          key: option.id,
          value: option.value,
          className: styles.nativeOption
        }, option.value);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _native = _this$props2["native"],
          dataHook = _this$props2.dataHook,
          popoverProps = _this$props2.popoverProps,
          dropDirectionUp = _this$props2.dropDirectionUp,
          dropdownWidth = _this$props2.dropdownWidth;
      var placement = dropDirectionUp ? 'top' : popoverProps.placement;
      var body = popoverProps.appendTo === 'window';
      return !_native ? /*#__PURE__*/React.createElement(Popover, _extends({}, styles('root', {}, this.props), DEFAULT_POPOVER_PROPS, {
        dynamicWidth: body,
        excludeClass: this.uniqueId
      }, popoverProps, {
        width: dropdownWidth,
        placement: placement,
        dataHook: dataHook,
        onKeyDown: this._onKeyDown,
        onClickOutside: this.onClickOutside,
        shown: this.isDropdownLayoutVisible()
      }), /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement("div", {
        "data-input-parent": true,
        className: this.inputClasses()
      }, this.renderInput())), /*#__PURE__*/React.createElement(Popover.Content, null, this._renderDropdownLayout())) : this._renderNativeSelect();
    }
  }, {
    key: "showOptions",
    value: function showOptions() {
      if (!this.state.showOptions) {
        this.setState({
          showOptions: true,
          lastOptionsShow: Date.now()
        });
        this.props.onOptionsShow && this.props.onOptionsShow();
      }
    }
  }, {
    key: "hideOptions",
    value: function hideOptions() {
      if (this.state.showOptions) {
        this.setState({
          showOptions: false
        });
        this.props.onOptionsHide && this.props.onOptionsHide();
        this.props.onClose && this.props.onClose();
      }
    }
  }, {
    key: "closeOnSelect",
    value: function closeOnSelect() {
      return this.props.closeOnSelect;
    }
  }, {
    key: "shouldOpenDropdown",

    /**
     * Determine if the provided key should cause the dropdown to be opened.
     *
     * @param {KeyboardEvent.key}
     * @returns {boolean}
     */
    value: function shouldOpenDropdown(key) {
      var openKeys = this.isReadOnly ? ['Enter', 'Spacebar', ' ', 'ArrowDown'] : ['ArrowDown'];
      return openKeys.includes(key);
    }
    /**
     * Determine if the provided key should delegate the keydown event to the
     * DropdownLayout.
     *
     * @param {KeyboardEvent.key}
     * @returns {boolean}
     */

  }, {
    key: "shouldDelegateKeyDown",
    value: function shouldDelegateKeyDown(key) {
      return this.isReadOnly || !['Spacebar', ' '].includes(key);
    }
    /**
     * Determine if the provided key should cause manual submit.
     *
     * @param {KeyboardEvent.key}
     * @returns {boolean}
     */

  }, {
    key: "shouldPerformManualSubmit",
    value: function shouldPerformManualSubmit(key) {
      return this.getManualSubmitKeys().includes(key);
    }
  }, {
    key: "_onManuallyInput",
    value: function _onManuallyInput() {
      var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (this.state.isComposing) {
        return;
      }

      inputValue = inputValue.trim();
      var suggestedOption = this.props.options.find(function (element) {
        return element.value === inputValue;
      });

      if (this.props.onManuallyInput) {
        this.props.onManuallyInput(inputValue, suggestedOption);
      }
    }
  }, {
    key: "_onSelect",
    value: function _onSelect(option, isSelectedOption) {
      var onSelect = this.props.onSelect;

      if (this.closeOnSelect() || isSelectedOption) {
        this.hideOptions();
      }

      if (onSelect) {
        onSelect(this.props.highlight ? this.props.options.find(function (opt) {
          return opt.id === option.id;
        }) : option);
      }
    }
  }, {
    key: "_onChange",
    value: function _onChange(event) {
      this.setState({
        inputValue: event.target.value
      });

      if (this.props.onChange) {
        this.props.onChange(event);
      } // If the input value is not empty, should show the options


      if (event.target.value.trim() && !this.props["native"]) {
        this.showOptions();
      }
    }
  }, {
    key: "_onInputClicked",
    value: function _onInputClicked(event) {
      if (this.state.showOptions) {
        if (Date.now() - this.state.lastOptionsShow > 2000) {
          this.hideOptions();
        }
      } else {
        this.showOptions();
      }

      if (this.props.onInputClicked) {
        this.props.onInputClicked(event);
      }
    }
  }, {
    key: "_onFocus",
    value: function _onFocus(e) {
      if (this.props.disabled) {
        return;
      }

      this._focused = true;
      this.setState({
        isEditing: false
      });

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "_onBlur",
    value: function _onBlur(e) {
      this._focused = false;

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(event) {
      if (this.props.disabled) {
        return;
      }

      var key = event.key;
      /* Enter - prevent a wrapping form from submitting when hitting Enter */

      /* ArrowUp - prevent input's native behaviour from moving the text cursor to the beginning */

      if (key === 'Enter' || key === 'ArrowUp') {
        event.preventDefault();
      }

      if (key !== 'ArrowDown' && key !== 'ArrowUp') {
        this.setState({
          isEditing: true
        });
      }

      if (this.shouldOpenDropdown(key)) {
        this.showOptions();
        event.preventDefault();
      }

      if (this.shouldDelegateKeyDown(key)) {
        // Delegate event and get result
        if (this.dropdownLayout) {
          var eventWasHandled = this.dropdownLayout._onKeyDown(event);

          if (eventWasHandled || this.isReadOnly) {
            return;
          }
        } // For editing mode, we want to *submit* only for specific keys.


        if (this.shouldPerformManualSubmit(key)) {
          this._onManuallyInput(this.state.inputValue, event);

          var inputIsEmpty = !event.target.value;

          if (this.closeOnSelect() || key === 'Tab' && inputIsEmpty) {
            this.hideOptions();
          }
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.input.focus(options);
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "isReadOnly",
    get: function get() {
      var _ref = this.inputAdditionalProps() || {},
          readOnly = _ref.readOnly;

      return readOnly;
    }
  }]);

  return InputWithOptions;
}(Component);

InputWithOptions.defaultProps = _objectSpread(_objectSpread(_objectSpread({}, Input.defaultProps), DropdownLayout.defaultProps), {}, {
  onSelect: function onSelect() {},
  options: [],
  closeOnSelect: true,
  inputElement: /*#__PURE__*/React.createElement(Input, null),
  valueParser: DEFAULT_VALUE_PARSER,
  dropdownWidth: null,
  popoverProps: DEFAULT_POPOVER_PROPS,
  dropdownOffsetLeft: '0',
  showOptionsIfEmptyInput: true,
  autocomplete: 'off',
  "native": false
});
InputWithOptions.propTypes = _objectSpread(_objectSpread(_objectSpread({}, Input.propTypes), DropdownLayout.propTypes), {}, {
  autocomplete: PropTypes.string,
  inputElement: PropTypes.element,
  closeOnSelect: PropTypes.bool,
  onManuallyInput: PropTypes.func,
  onOptionsShow: PropTypes.func,
  onOptionsHide: PropTypes.func,

  /** Function that receives an option, and should return the value to be displayed. By default returns `option.value`. */
  valueParser: PropTypes.func,
  dropdownWidth: PropTypes.string,
  dropdownOffsetLeft: PropTypes.string,

  /** Controls whether to show options if input is empty */
  showOptionsIfEmptyInput: PropTypes.bool,
  highlight: PropTypes.bool,

  /** Indicates whether to render using the native select element */
  "native": PropTypes.bool,

  /** common popover props */
  popoverProps: PropTypes.shape({
    appendTo: PropTypes.oneOf(['window', 'scrollParent', 'parent', 'viewport']),
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    flip: PropTypes.bool,
    fixed: PropTypes.bool,
    placement: PropTypes.oneOf(placements),
    dynamicWidth: PropTypes.bool
  })
});
InputWithOptions.displayName = 'InputWithOptions';
export default InputWithOptions;